import { ApiInstance } from '..'
import { IPointListParams, IPointListResp, IPointStatAllResp } from './type'

export const getPointStatAll = () => {
  return ApiInstance.post<IPointStatAllResp>('', { cmd: 'apid.get_point_stat_all' })
}

export const getPointList = (params: IPointListParams) => {
  return ApiInstance.post<IPointListResp>('', { cmd: 'apid.get_point_rank_list', para: params })
}
